export default __webpack_public_path__ + "static/media/appStore_download.069a4c0a.svg";